import React from "react";
import classNames from "classnames";

export const CardHr = ({ title, subtitle, icon, className, bgColor }) => {
  return (
    <div
      className={`flex flex-row items-center md:justify-between justify-between gap-2 !min-w-full md:h-[80px] h-[100px] p-3 pl-0 rounded-md ${className} ${
        bgColor ? bgColor : 'bg-white'
      }`}
    >
      <div className='flex flex-col items-start justify-end'>
        <div className='flex w-full justify-end font-medium text-[12px] leading-[12px] text-[#000005] text-right'>
          {title}
        </div>
        <div className='mt-1'>
          <span className='font-bold text-[18px]'>{subtitle}</span>
        </div>
      </div>
      <div
        className={classNames('flex justify-center items-center min-w-[40px] ')}
      >
        <img src={icon} alt='' height={'40px'} width={'40px'} />
      </div>
    </div>
  )
}
